import { render } from "./vitals-box.vue?vue&type=template&id=39ff9234&scoped=true"
import script from "./vitals-box.vue?vue&type=script&lang=js"
export * from "./vitals-box.vue?vue&type=script&lang=js"

import "./vitals-box.vue?vue&type=style&index=0&id=39ff9234&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/hkust-gz-vitals/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ff9234"]])

export default __exports__